import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWA/components/l10n";
import { HotelWizardStateProps } from "components/flexComponents/WizardHotelPWAv2/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkCheckbox } from "uitk-react-switch";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

const CheckboxTracked = FlexClickTracker(UitkCheckbox);

export interface HotelAddCarCheckboxProps extends HotelWizardStateProps {
  updatePackageOnReflection: () => void;
}

export const HotelAddCarCheckbox = observer(
  ({ hotelWizardState, updatePackageOnReflection }: HotelAddCarCheckboxProps) => {
    const { formatText } = useLocalization();

    const handleChange = () => {
      hotelWizardState.toggleAddACarCheckbox();
      updatePackageOnReflection();
    };

    return (
      <UitkLayoutFlexItem>
        <CheckboxTracked
          id="add-car-switch"
          checked={hotelWizardState.isAddACarChecked}
          onChange={handleChange}
          disabled={hotelWizardState.isMultiplePlacesChecked}
          moduleName="WizardHotelPWAv2"
          rfrr="SoftPackage_Car"
        >
          {formatText(locKeys.addCarLabel)}
        </CheckboxTracked>
      </UitkLayoutFlexItem>
    );
  }
);
